import api from './api';

export const createPayslip = (employeeId, data) => api.post(`/employees/${employeeId}/payslips`, data);
export const listPayslips = (employeeId) => api.get(`/employees/${employeeId}/payslips`);
export const getPayslip = (payslipId) => api.get(`/employees/payslips/${payslipId}`);
export const updatePayslip = (payslipId, data) => api.put(`/employees/payslips/${payslipId}`, data);
export const deletePayslip = (payslipId) => api.delete(`/employees/payslips/${payslipId}`);

export default { createPayslip, listPayslips, getPayslip, updatePayslip, deletePayslip };
